import type { GridValidRowModel } from "@mui/x-data-grid-premium";
import { get } from "react-hook-form";
import type { SelectLabelProp } from "./system.types";
import { SELECT_DEFAULT_LABEL_PROP } from "src/system/constants.ts";

export const getSelectLabel = <
  Resource extends GridValidRowModel = GridValidRowModel,
>({
  item,
  labelProp,
}: {
  item: Resource;
  labelProp?: SelectLabelProp<Resource>;
}) => {
  if (typeof labelProp === "function") {
    return labelProp(item);
  }
  return get(item, labelProp ?? SELECT_DEFAULT_LABEL_PROP);
};
